export default __webpack_public_path__ + "static/psgCard2-6695e84c29a7cbeaeba313a4aed1983b.webp";